import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { roleGuard } from './general/shared/guards/role.guard';
import { AdminNotificationService } from './modules/notifications/admin-notification.service';
import type { NotificationsComponent } from './modules/notifications/notifications.component';
import type { AddUserComponent } from './modules/users/components/add-user/add-user.component';
import type { MultipleAssignmentComponent } from './modules/users/components/multiple-assignment/multiple-assignment.component';

export const appRoutes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'users' },
	{
		path: 'users',
		loadComponent: () => import('./modules/users/users.component').then((m) => m.UsersComponent),
		canActivate: [MsalGuard, roleGuard],
	},
	{
		path: 'users/create',
		loadComponent: () =>
			import('./modules/users/components/add-user/add-user.component').then(
				(m) => m.AddUserComponent
			),
		canActivate: [MsalGuard, roleGuard],
		canDeactivate: [(component: AddUserComponent) => component.canDeactivate()],
	},
	{
		path: 'users/assign',
		loadComponent: () =>
			import('./modules/users/components/multiple-assignment/multiple-assignment.component').then(
				(m) => m.MultipleAssignmentComponent
			),
		canActivate: [MsalGuard, roleGuard],
		canDeactivate: [(component: MultipleAssignmentComponent) => component.canDeactivate()],
	},
	{
		path: 'vehicles',
		loadComponent: () =>
			import('./modules/vehicles/vehicles.component').then((m) => m.VehiclesComponent),
		canActivate: [MsalGuard, roleGuard],
	},
	{
		path: 'notifications',
		loadComponent: () =>
			import('./modules/notifications/notifications.component').then(
				(m) => m.NotificationsComponent
			),
		canActivate: [MsalGuard, roleGuard],
		canDeactivate: [(component: NotificationsComponent) => component.form()?.canDeactivate()],
		providers: [AdminNotificationService],
	},
	{ path: '**', redirectTo: 'users' },
];
